import { buildRechercheStore } from '../storeRechercheBuilder'
import type { FactureDTO } from '@/features/api/extranet/dto/Facture/FactureDTO'
import type { FactureQueryDTO } from '@/features/api/extranet/dto/Facture/FactureQueryDTO'

export const useRechercheFactureStore = buildRechercheStore<FactureQueryDTO, FactureDTO>({
  storeName: 'rechercheFactureStore',
  apiPath: '/factures',
})

